export var Theme;
(function (Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})(Theme || (Theme = {}));
export var TextSizes;
(function (TextSizes) {
    TextSizes["S"] = "s";
    TextSizes["M"] = "m";
    TextSizes["L"] = "l";
})(TextSizes || (TextSizes = {}));
export var ControlSizes;
(function (ControlSizes) {
    ControlSizes["M"] = "m";
    ControlSizes["L"] = "l";
})(ControlSizes || (ControlSizes = {}));
export var Vcs;
(function (Vcs) {
    Vcs["Github"] = "github";
    Vcs["Arcanum"] = "arcanum";
})(Vcs || (Vcs = {}));
export var Lang;
(function (Lang) {
    Lang["Ru"] = "ru";
    Lang["En"] = "en";
})(Lang || (Lang = {}));
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["like"] = "like";
    FeedbackType["dislike"] = "dislike";
    FeedbackType["indeterminate"] = "indeterminate";
})(FeedbackType || (FeedbackType = {}));
export var SubscribeType;
(function (SubscribeType) {
    SubscribeType["documentation"] = "documentation";
    SubscribeType["page"] = "page";
})(SubscribeType || (SubscribeType = {}));
